<template>
    <v-btn v-if="!isGuest"
		   ref="download-co-button"
		   :disabled="isDisabled"
           @click="onClick"
           v-tippy="{placement: 'left'}"
           content="Download Capture One Style"
    >
        <img src="/assets/icons/co-icon-96x96.png" />
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image', 'currentFile']),
        ...mapState("UI", ['startTips', 'showAddMatchTooltip']),
        ...mapGetters('User', ['isGuest']),
		isDisabled() {
            return !this.canExportCO || !this.image || this.IDT.initial || this.blockLoading
		}
    },
    mounted() {
        this.$root.$refs.downloadCOButton = this.$refs['download-co-button'];
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;
            // if (lutify.isCurrentPlanFree()) {
            //     UI.showModal(UI.modals.notAvailableInFree.el);
            //     return;
            // }

            this.$store.dispatch('UI/setRightColumn', 'download-co')
		}
	}
}
</script>

<style lang="scss" scoped>
.v-btn--disabled {
	img {
        opacity: 0.4;
	}
}

img {
    width: 20px;
}
</style>